import { useState, useEffect } from 'react';

import { type QtiSegmentQuestionDTO } from '../../models';
import { DynamicTextPreview, type QuestionRendererOptions, defaultOptions } from '@/src/lib';
import { SimpleSwitch } from '@/src/ui';

interface SegmentRendererProps {
    question: QtiSegmentQuestionDTO;
    showLanguageToggle?: boolean;
    options?: QuestionRendererOptions;
}

export default function SegmentRenderer({
    question,
    options = defaultOptions,
}: SegmentRendererProps) {
    const { hidePrompt = false, showLanguageToggle = false, language = 'en' } = options;

    // Language may need to be hanldled internally if it is not controlled from the outside
    const [internalLanguage, setInternalLanguage] = useState<'en' | 'es'>(language);
    useEffect(() => {
        setInternalLanguage(language);
    }, [language]);

    return (
        <div
            onContextMenu={(e) => {
                if (options.onRendererContextMenu) {
                    e.preventDefault();
                    e.stopPropagation();
                    options.onRendererContextMenu(
                        e,
                        {
                            language: internalLanguage,
                            text: question.prompt,
                            text_es: question.prompt_es,
                        },
                        []
                    );
                }
            }}
        >
            {!hidePrompt && (
                <>
                    {showLanguageToggle && question.meta.isSpanishAllowed && (
                        <div className="flex flex-row gap-x-8">
                            <div className="ml-auto">
                                <SimpleSwitch
                                    name="toggleSpanish"
                                    checked={internalLanguage === 'es'}
                                    onChange={(e) =>
                                        setInternalLanguage(e.target.checked ? 'es' : 'en')
                                    }
                                    label="View Spanish"
                                />
                            </div>
                        </div>
                    )}
                    <DynamicTextPreview
                        content={internalLanguage === 'en' ? question.prompt : question.prompt_es}
                    />
                </>
            )}
        </div>
    );
}
